import { ReturnsAndClaimsPermissions } from "@redotech/account-common/permissions";
import { SortDirection } from "@redotech/cockroachdb-codegen/congodb/sort-direction";
import { WithdrawalListView } from "@redotech/merchant-sdk/rpc/schema/withdrawals/list-withdrawals";
import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo, useContext } from "react";
import { useLocation, useMatch } from "react-router-dom";
import {
  OrderManagementSuiteStatusesContext,
  WITHDRAWAL_ICON,
  WITHDRAWAL_ICON_FILLED,
} from "../../../../redo-suite/order-management-cloud";

const WithdrawalItemContent = memo(function WithdrawalItemContent() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const merchantRpc = useRequiredContext(RedoMerchantRpcClientContext);
  const location = useLocation();

  const withdrawalMatch = useMatch(`${routes.withdrawalHref}/*`);
  const anyChildSelected = !!withdrawalMatch;
  const needsActionCountLoad = useLoad(async () => {
    const result = await merchantRpc.listWithdrawals({
      view: WithdrawalListView.NEEDS_ACTION,
      pageSize: 1,
      offset: 0,
      sortDirection: SortDirection.Desc,
      search: undefined,
      advancedFiltersData: undefined,
    });
    return result.total;
  }, [location.pathname, merchantRpc]);

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getWithdrawalHref() }}
      anyChildSelected={anyChildSelected}
      FilledIcon={WITHDRAWAL_ICON_FILLED}
      friendlyName="Withdrawals"
      id="withdrawal"
      notificationCount={needsActionCountLoad.value}
      UnfilledIcon={WITHDRAWAL_ICON}
    >
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.getWithdrawalSubRoute("all-withdrawals"),
        }}
        friendlyName="All withdrawals"
        id="all-withdrawals"
      />
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.getWithdrawalSubRoute("needs-action"),
        }}
        friendlyName="Needs action"
        id="withdrawal-needs-action"
        notificationCount={needsActionCountLoad.value}
      />
    </RedoSecondaryNavItem>
  );
});

export const WithdrawalItem = memo(function WithdrawalItem() {
  const hasPermissionToViewItem = useHasPermission(
    ReturnsAndClaimsPermissions.MANAGE_WITHDRAWAL_REQUESTS,
  );
  const { withdrawalEnabled } = useContext(OrderManagementSuiteStatusesContext);

  if (!hasPermissionToViewItem || !withdrawalEnabled) {
    return null;
  }

  return <WithdrawalItemContent />;
});
